import React from "react";

const customers = [
    {
        name: "Welspun",
        applications: ["Wel DMS", "Wel SFA"]
    },
    {
        name: "Jaideep",
        applications: ["Jaideep SFA", "Jaideep Distributor App"]
    },
    {
        name: "JK Paper",
        applications: ["JK Paper"]
    }
];

export default function PrivacyPolicy() {
    return (
        <div className="max-w-6xl mx-auto px-4 py-10 text-white">
            <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
            <p className="text-center mb-4 text-sm text-gray-500">
                Last Updated: April 5, 2025
            </p>

            <p className="mb-6">
                This Privacy Policy governs the manner in which our IT company collects, uses,
                maintains and discloses information collected from users of our services. It applies
                to all products, platforms, websites, and mobile applications provided to our
                customers and end-users.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Our Clients</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                {customers.map((c, i) => (
                    <li key={i}>
                        <strong>{c.name}</strong>: {c.applications.join(", ")}
                    </li>
                ))}
            </ul>

            <h2 className="text-2xl font-semibold mb-4">1. Data Collection</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Device details: model, OS, unique identifiers</li>
                <li>Personal identifiers like name, email, and phone number</li>
                <li>Location (only with explicit permission)</li>
                {/* <li>App usage: screen visits, session times, crash logs</li>
       
        <li>Application-specific analytics for performance improvement</li> */}
            </ul>

            <h2 className="text-2xl font-semibold mb-4">2. User Data Privacy Commitments</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>We do not sell, rent or trade user data.</li>
                {/* <li>End-to-end encryption and security best practices are enforced.</li> */}
                <li>Access to sensitive data is strictly limited.</li>
                <li>Users can review, update or request deletion of their data.</li>
                {/* <li>Permissions are clearly disclosed and optional where applicable.</li> */}
            </ul>

            <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>To improve performance and user experience</li>
                <li>To provide necessary features like login, sync, location</li>
                <li>To ensure legal and operational compliance</li>
                <li>To communicate product updates or bug fixes</li>
            </ul>

            <h2 className="text-2xl font-semibold mb-4">4. Children’s Privacy</h2>
            <p className="mb-6">
                Our applications are not designed for or intended to attract children under the
                age of 13. We do not knowingly collect personal information from children.
            </p>

            <h2 className="text-2xl font-semibold mb-4">5. Third-Party Services</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">

                <li>Google Analytics – for anonymous usage tracking</li>
                <li>Google Firebase – for authentication and crash reporting</li>
                <li>Google Maps – for map-related functionalities</li>
                {/* <li>All third parties are selected for compliance and reliability</li> */}
            </ul>

            <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
            <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Request access to your stored personal data</li>
                <li>Request data correction or deletion</li>
                {/* <li>Withdraw permissions at any time from your settings</li> */}
                <li>Contact our team regarding privacy concerns</li>
            </ul>

            <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
            <p className="mb-2">
                If you have questions or concerns about our privacy practices, please contact us:
            </p>
            <p className="mb-1">📧 Email: <strong>developer@uniproworld.com</strong></p>
            <p>🌐 Website: <strong>www.uniproworld.com</strong></p>
        </div>
    );
}
